import {Injectable} from '@angular/core';
import {RequestService} from '../../../service/request.service';
import {CachedWsResourceClient} from '../../../private_util/client/cached-http-ws-Resource-client';
import {AuthProvider} from '../../../domain/auth/auth-provider';
import {AppConfigService} from '../../../../service/config/app-config.service';
import {WsDaoEventEntityType, WsProduct, WsRef} from '@lifeislife/lifeislife-ws-api';
import {ResourceCacheService} from '../../../../util/cache/resource-cache.service';

@Injectable({
  providedIn: 'root',
})
export class ProductWsClient extends CachedWsResourceClient<WsProduct, WsRef<WsProduct>> {

  constructor(private injectedRequestService: RequestService,
              private injectectedCacheService: ResourceCacheService,
              private injectedAuthService: AuthProvider,
              private injectedAppConfigService: AppConfigService) {
    super('/front/product', injectedAppConfigService, injectedRequestService, injectedAuthService,
      WsDaoEventEntityType.PRODUCT, injectectedCacheService);
  }

}
